export default __webpack_public_path__ + "static/media/vintage100-7.9deedcf0.jpg";